module.exports = __webpack_public_path__ + "static/media/calender-rs.a6d3ada3.svg";